import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handleAdminLogin, handleAdminLogout } from "../../services/APIClient";
import { STATUS_CODES } from "../../utils/statusCode";

const initialState = {
  userData: {},
};

// Thunk for user login
export const userLogin = createAsyncThunk(
  "admin/login",
  async (data, { rejectWithValue }) => {
    try {
      const response = await handleAdminLogin(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Thunk for user logout
export const userLogout = createAsyncThunk(
  "admin/logout",
  async (data, { rejectWithValue }) => {
    try {
      const response = await handleAdminLogout(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    //Function for storing userData
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    updateUserProfile: (state, action) => {
      const { value } = action.payload;

      state.userData["profileImg"] = value;
    },
    removeUserData: (state, action) => {
      state.userData = action.payload;
      state.userToken = null;
      state.loginType = null;
      state.user_language = "";
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    //======= user login======
    builder.addCase(userLogin.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(userLogin.fulfilled, (state, action) => {
      state.isLoading = false;
      const response = action.payload;
      if (response && response.code === STATUS_CODES.SUCCESS) {
        state.userToken = response.data.token;
        state.loginType = response.data.signup_type;
        // state.currentUser = response.data; //
        state.user_language = response.data.locale;
        state.success = true;
      } else {
        state.userToken = null;
        state.user_language = ""; //
        state.success = false;
      }
    });
    builder.addCase(userLogin.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export default userSlice.reducer;
export const { setUserData, removeUserData, updateUserProfile } =
  userSlice.actions;
